module.exports = __webpack_public_path__ + "static/media/checkedWhite.ed7cddf7.svg";